export type ProxyPlayback =
	| ProxyPlaybackReady
	| ProxyPlaybackPending
	| ProxyPlaybackErrored
	| ProxyPlaybackNotAvailable;

/** A proxy job that got returned successfuly. */
export interface ProxyPlaybackReady {
	status: 'ready';
	manifest: string;
	expiresInSeconds: number;
	audioConfig?: string;
	outdated?: boolean;
	drm: ProxyPlaybackDrmConfig;
}

/** A proxy job that exists and is still running. */
export interface ProxyPlaybackPending {
	status: 'pending';
}

/** The proxy job failed, or its output cannot be played. */
export interface ProxyPlaybackErrored {
	status: 'errored';
	reason?: string;
}

/** No proxy job exists for this object — folder, non-media file, or generation never ran. */
export interface ProxyPlaybackNotAvailable {
	status: 'notAvailable';
}

/** DRM systems the Mezz Proxy pipeline issues licenses for. Safari/FairPlay needs an HLS output and is not covered. */
export type ProxyDrmSystem = 'widevine' | 'playready';

export interface ProxyPlaybackDrmConfig {
	licenseServers: Partial<Record<ProxyDrmSystem, string>>;
	token: string;
	keyIds: string[];
}

export function offeredLicenseServers(
	licenseServers: ProxyPlaybackDrmConfig['licenseServers'],
): [ProxyDrmSystem, string][] {
	return Object.entries(licenseServers).filter((entry): entry is [ProxyDrmSystem, string] => !!entry[1]);
}
